import { useLocation } from 'react-router';

export default (): string | undefined => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const searchTextSearch = search.get('searchText');
  return searchTextSearch || undefined;
};
